export const SET_CAT_CARD = 'viewer/cats/SET_CAT_CARD';
export const SET_CAT_RANKING = 'viewer/cats/SET_CAT_RANKING';
